import { QuestionVariety } from "./Definition";
import { SingleValueQuestion } from "./SingleValueQuestion";

export default class SimpleTextQuestion extends SingleValueQuestion {
  get type(): QuestionVariety {
    return "text_simple";
  }
}
